import React, { useEffect, useState } from 'react';
import axios from 'axios';
import configApi from '../../config';

const PopularTermTypes = () => {
  const [types, setTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const token = localStorage.getItem("token");
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    axios.get(`${configApi.apiEndpoint}/api/Stats/PopularTermTypes`, config)
      .then(response => {
        setTypes(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.error('There was an error fetching the popular term types:', error);
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return (
      <div className='sum-card'>
        <h4>Populárne typy termínov</h4>
        <ul className='poptermtypes' style={{ listStyleType: 'none', padding: 0 }}>
          {[1, 2, 3].map((i) => (
            <li key={`skel-${i}`} className="mb-2">
              <div className="skeleton-box" style={{ width: '150px', height: '20px' }}></div>
            </li>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <div className='sum-card'>
      <h4>Populárne typy termínov</h4>
      <ul className='poptermtypes'>
        {types.map((type, index) => (
          <li key={index}>
            {type.termTypeName ? type.termTypeName : "Bez kategórie"}: {type.count}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PopularTermTypes;
